import type { HomologationStatus } from '@/components/ProductCard/types'
import type { GalleryModelVariant } from '@/types/catalog'

export const HOMOLOGATION_STATUS_COLOR: Record<HomologationStatus, string> = {
  'OK': 'var(--vp-semantic-color-status-positive)',
  'PENDING': 'var(--vp-semantic-color-status-warning)',
  'NOT OK': 'var(--vp-semantic-color-status-negative)',
  'UNVERIFIED': 'var(--vp-semantic-color-content-quiet)',
}

export function getIconFromStatus(status: HomologationStatus) {
  switch (status) {
    case 'OK':
      return 'check-circle'
    case 'PENDING':
      return 'warning-error'
    case 'NOT OK':
      return 'close-circle'
    case 'UNVERIFIED':
      return 'time'
  }
}

const VALID_GENDER_IDS = new Set(['2', '3', '5', '6', '8', '9', '10', '11', '12', '13'])

export const isGenderValid = (genderId: string) => VALID_GENDER_IDS.has(genderId)

export function displayGenders(
  genders: { id: string }[],
  t: (key: string, options?: Record<string, unknown>) => string,
) {
  return genders
    .map(gender => t(`products-page.product-card.gender-id.${isGenderValid(gender.id) ? gender.id : 'unknown'}`))
    .join(', ')
}

const NUMERIC_CLOTHING_SIZE_PATTERN = /^(\d+)(XS|XL)$/i
const X_CLOTHING_SIZE_PATTERN = /^(X+)(S|L)$/i

function getClothingSizeRank(size: string) {
  const normalizedSize = size.trim().toUpperCase()

  if (normalizedSize === 'S')
    return 0
  if (normalizedSize === 'M')
    return 1
  if (normalizedSize === 'L')
    return 2

  const numericMatch = NUMERIC_CLOTHING_SIZE_PATTERN.exec(normalizedSize)
  const xMatch = X_CLOTHING_SIZE_PATTERN.exec(normalizedSize)

  if (!numericMatch && !xMatch)
    return undefined

  const suffix = numericMatch?.[2] ?? xMatch?.[2] ?? ''

  const multiplier = numericMatch ? Number(numericMatch[1]) : xMatch![1].length
  return suffix.endsWith('S') ? -multiplier : 2 + multiplier
}

export function sortSizeVariants(variants: GalleryModelVariant[]) {
  const clothingSizes = variants.map(variant => getClothingSizeRank(variant.size))
  const isClothingSizeGrid = clothingSizes.every(rank => rank !== undefined)

  return [...variants].sort((firstVariant, secondVariant) => {
    if (isClothingSizeGrid) {
      return getClothingSizeRank(firstVariant.size)! - getClothingSizeRank(secondVariant.size)!
    }

    return firstVariant.size.localeCompare(secondVariant.size, undefined, { sensitivity: 'base' })
  })
}
